import { ReactElement } from 'react';
import { Outlet, Navigate, NavLink } from 'react-router-dom';
import { SystemAdminTopBar } from '../SystemAdminTopBar';
import classes from './SystemAdminLayout.module.css';
import { useGetUserinfo } from '../../hooks/queries/useGetUserinfo';
import { UserRoles } from '../../api/queries';
import { PageLoader } from '../PageLoader/PageLoader';
import { Routes } from '../../enums/Routes';
import { useRouterMetadataContext } from '../../contexts/routerMetaDataContext';

const isSuperAdmin = (userRoles?: string[]): boolean => {
  return userRoles?.includes(UserRoles.SUPER_ADMIN) ?? false;
};

export const SystemAdminLayout = (): ReactElement => {
  const { data: userInfo, isLoading } = useGetUserinfo();
  const { shouldBeInFocusMode } = useRouterMetadataContext();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!isSuperAdmin(userInfo?.userRoles)) {
    return <Navigate to={Routes.Dashboard} replace />;
  }

  return (
    <div className={classes.container}>
        {!shouldBeInFocusMode && <SystemAdminTopBar />}
        {!shouldBeInFocusMode && (
          <nav className={classes.navigation}>
          <NavLink
            to={Routes.SystemAdminDashboard}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Dashboard"
          >
            Dashboard
          </NavLink>
          <NavLink
            to={Routes.SystemAdminTenants}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Kunder"
          >
            Kunder
          </NavLink>
          <NavLink
            to={Routes.SystemAdminPartners}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Partnere"
          >
            Partnere
          </NavLink>
          <NavLink
            to={Routes.SystemAdminPartnerLeadsOverview}
            className={({ isActive }) =>
              isActive ? `${classes.navLink} ${classes.active}` : classes.navLink
            }
            aria-label="Gå til Partner Pipeline"
          >
            Partner Pipeline
          </NavLink>
        </nav>
      )}
      <main className={classes.main}>
        <Outlet />
      </main>
    </div>
  );
};
